import { EditShop } from '../pages';

export const ShopRoutes = [
  {
    path: '/legacy-loja', // leave this hidden until we assert that vendors-portal /marca/editar is ok
    exact: true,
    isPrivate: true,
    component: <EditShop />,
  },
];
